import React from 'react'
import { getSession, getMerchantId } from '../../utils/api'
import { getShopTerminalsAPI } from '../../api/shop'
import { mfeConfigs } from '../../utils/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'

export const PaymentPage = (props) => {
  let authToken = null
  const session = getSession()
  authToken = session && session.accessToken
  const merchantId = getMerchantId()
  const platform = 'pos'

  const isBlazeEmployee = () => {
    const employeeEmail = session?.employee?.email
    if (!employeeEmail) return false

    const regex = /^[^\s@]+@((s|ext)\.)?blaze\.me$/i
    return regex.test(employeeEmail)
  }

  return (
    <SingleSpaParcel
      {...props}
      basename="settings/shop/newPaymentOptions"
      authToken={authToken}
      merchantId={merchantId}
      platform={platform}
      isBlazeEmployee={isBlazeEmployee()}
      services={{
        terminalListService: {
          fetchTerminalOptions: async (provider) =>
            new Promise(async (resolve, reject) => {
              try {
                const response = await getShopTerminalsAPI(session.assignedShop.id)
                if (response.status < 200 || response.status >= 300) {
                  throw new Error(`Failed to fetch terminal options. Status: ${response.status}`)
                }
                const formattedData = response.values
                  ? response.values
                      .filter((value) => value.active)
                      .map((value) => ({ terminalId: value.id, terminalName: value.name }))
                  : []
                resolve(formattedData)
              } catch (error) {
                console.error('Error fetching terminal options:', error)
                reject(error)
              }
            }),
        },
      }}
      config={mfeConfigs.LOAD_PAYMENT_PAGE}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/MfeParcels/PaymentPage.js